{
  "familyId": "GELD-PRIJS-PER",
  "questions": [
    {
      "id": "GELD-PRIJS-PER-001",
      "familyId": "GELD-PRIJS-PER",
      "module": "Geld",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_prijs_per_eenheid",
      "questionType": "multiple_choice",
      "question": "Een pak van 500 gram kaas kost €4,50. Een pak van 300 gram kost €3,00. Welk pak is goedkoper per kilogram?",
      "context": "Je vergelijkt twee pakken kaas in de supermarkt om de beste deal te vinden.",
      "options": ["Het pak van 500 gram", "Het pak van 300 gram", "Ze zijn even duur", "Dat kun je niet berekenen"],
      "correctAnswer": 0,
      "conceptId": "prijs_per_kg_vergelijken",
      "variantIndex": 1,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "geld.total-vs-unit-price", "label": "Totaalprijs verward met eenheidsprijs", "optionIndex": 1 },
          { "id": "geld.total-vs-unit-price", "label": "Totaalprijs verward met eenheidsprijs", "optionIndex": 2 }
        ]
      },
      "stimulusAids": [
        {
          "type": "priceCompare",
          "data": {
            "items": [
              { "name": "Groot pak", "quantity": 0.5, "unit": "kg", "totalPrice": 4.50 },
              { "name": "Klein pak", "quantity": 0.3, "unit": "kg", "totalPrice": 3.00 }
            ],
            "compareUnit": "per kg",
            "label": "Vergelijk de prijs per kilogram"
          }
        }
      ],
      "supportAids": [
        {
          "type": "priceCompare",
          "showWhen": "wrong",
          "data": {
            "items": [
              { "name": "Groot pak (500 g)", "quantity": 0.5, "unit": "kg", "totalPrice": 4.50 },
              { "name": "Klein pak (300 g)", "quantity": 0.3, "unit": "kg", "totalPrice": 3.00 }
            ],
            "compareUnit": "per kg",
            "label": "Prijs per kilogram berekenen"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bereken de prijs per kg voor beide pakken. Pak 500 g: €4,50 ÷ 0,5 kg = €9,00 per kg. Pak 300 g: €3,00 ÷ 0,3 kg = €10,00 per kg. Het pak van 500 gram is goedkoper per kilogram (€9 vs €10).",
        "solutionSteps": [
          "Pak 500 g = 0,5 kg → €4,50 ÷ 0,5 = €9,00 per kg",
          "Pak 300 g = 0,3 kg → €3,00 ÷ 0,3 = €10,00 per kg",
          "€9,00 < €10,00 → het pak van 500 g is goedkoper per kg"
        ],
        "distractorExplanations": {
          "0": "Goed! €9,00 per kg vs €10,00 per kg — het grote pak is goedkoper.",
          "1": "Je dacht waarschijnlijk dat het kleinere pak goedkoper is omdat het minder kost (€3,00 vs €4,50). Maar per kilogram is het duurder: €10,00/kg vs €9,00/kg. Onthoud: vergelijk altijd de prijs per eenheid.",
          "2": "Je dacht waarschijnlijk dat ze even duur zijn. Maar €4,50 ÷ 0,5 = €9,00/kg en €3,00 ÷ 0,3 = €10,00/kg. Dat is niet gelijk. Onthoud: bereken de prijs per kg.",
          "3": "Je dacht waarschijnlijk dat je dit niet kunt vergelijken. Maar door de prijs per kilogram te berekenen, kun je elk pak vergelijken. Onthoud: prijs ÷ gewicht in kg = prijs per kg."
        }
      }
    },
    {
      "id": "GELD-PRIJS-PER-002",
      "familyId": "GELD-PRIJS-PER",
      "module": "Geld",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_prijs_per_eenheid",
      "questionType": "multiple_choice",
      "question": "Een fles sap van 1,5 liter kost €2,25. Wat is de prijs per liter?",
      "context": "Je wilt weten hoeveel een liter sap kost om te vergelijken met andere merken.",
      "options": ["€1,50", "€2,25", "€0,75", "€3,00"],
      "correctAnswer": 0,
      "conceptId": "prijs_per_liter",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "geld.total-vs-unit-price", "label": "Totaalprijs verward met eenheidsprijs", "optionIndex": 1 },
          { "id": "geld.wrong-division-direction", "label": "Verkeerde deelrichting bij eenheidsprijs", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "priceCompare",
          "showWhen": "wrong",
          "data": {
            "items": [
              { "name": "Fles sap", "quantity": 1.5, "unit": "liter", "totalPrice": 2.25 }
            ],
            "compareUnit": "per liter",
            "label": "Prijs per liter berekenen"
          }
        }
      ],
      "feedback": {
        "explanationText": "Om de prijs per liter te berekenen, deel je de totaalprijs door het aantal liters. De fles kost €2,25 en bevat 1,5 liter. De som is dus: €2,25 ÷ 1,5 = €1,50 per liter. Je kunt dit controleren: 1,5 × €1,50 = €2,25.",
        "solutionSteps": [
          "Totaalprijs: €2,25",
          "Inhoud: 1,5 liter",
          "Prijs per liter: €2,25 ÷ 1,5 = €1,50"
        ],
        "distractorExplanations": {
          "0": "Goed! €2,25 ÷ 1,5 = €1,50 per liter.",
          "1": "Je dacht waarschijnlijk dat de totaalprijs ook de literprijs is. Maar €2,25 is voor 1,5 liter, niet voor 1 liter. Onthoud: deel de prijs door het aantal liters.",
          "2": "Je dacht waarschijnlijk dat je €2,25 ÷ 3 moest doen. Maar de fles is 1,5 liter, niet 3 liter. Onthoud: €2,25 ÷ 1,5 = €1,50.",
          "3": "Je dacht waarschijnlijk dat je €2,25 × 1,5 moest doen. Maar je moet delen, niet vermenigvuldigen. Onthoud: prijs per eenheid = totaalprijs ÷ aantal eenheden."
        }
      }
    },
    {
      "id": "GELD-PRIJS-PER-003",
      "familyId": "GELD-PRIJS-PER",
      "module": "Geld",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_prijs_per_eenheid",
      "questionType": "multiple_choice",
      "question": "In de supermarkt kosten 4 broodjes €3,60. Hoeveel kost één broodje?",
      "context": "Je wilt weten hoeveel één broodje kost als je er vier koopt.",
      "options": ["€0,90", "€0,80", "€1,20", "€0,60"],
      "correctAnswer": 0,
      "conceptId": "prijs_per_stuk",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "geld.wrong-division-direction", "label": "Verkeerde deelrichting bij eenheidsprijs", "optionIndex": 1 },
          { "id": "geld.wrong-division-direction", "label": "Verkeerde deelrichting bij eenheidsprijs", "optionIndex": 2 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Prijs per stuk",
            "content": "Deel de totaalprijs door het aantal stuks:\n€3,60 ÷ 4 = €0,90 per broodje.\nControleer: 4 × €0,90 = €3,60 ✓",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Om de prijs per stuk te berekenen, deel je de totaalprijs door het aantal stuks. De 4 broodjes kosten samen €3,60. De som is dus: €3,60 ÷ 4 = €0,90 per broodje. Je kunt dit controleren door terug te rekenen: 4 × €0,90 = €3,60.",
        "solutionSteps": [
          "Totaalprijs: €3,60",
          "Aantal: 4 broodjes",
          "Per stuk: €3,60 ÷ 4 = €0,90"
        ],
        "distractorExplanations": {
          "0": "Goed! €3,60 ÷ 4 = €0,90.",
          "1": "Je dacht waarschijnlijk dat €3,60 ÷ 4 = €0,80. Maar 4 × €0,80 = €3,20, en dat is niet €3,60. Onthoud: controleer door terug te vermenigvuldigen.",
          "2": "Je dacht waarschijnlijk dat je €3,60 ÷ 3 moest doen. Maar er zijn 4 broodjes, niet 3. Onthoud: lees goed hoeveel stuks er zijn.",
          "3": "Je dacht waarschijnlijk dat je €3,60 ÷ 6 moest doen. Maar er zijn 4 broodjes. Onthoud: €3,60 ÷ 4 = €0,90."
        }
      }
    },
    {
      "id": "GELD-PRIJS-PER-004",
      "familyId": "GELD-PRIJS-PER",
      "module": "Geld",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_prijs_per_eenheid",
      "questionType": "multiple_choice",
      "question": "Appels kosten €2,40 per kilogram. Hoeveel kosten 750 gram appels?",
      "context": "Je koopt 750 gram appels bij de groenteboer en wilt weten wat je moet betalen.",
      "options": ["€1,80", "€2,40", "€1,20", "€3,00"],
      "correctAnswer": 0,
      "conceptId": "prijs_deel_kg",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "geld.total-vs-unit-price", "label": "Totaalprijs verward met eenheidsprijs", "optionIndex": 1 },
          { "id": "geld.wrong-division-direction", "label": "Verkeerde deelrichting bij eenheidsprijs", "optionIndex": 2 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Prijs voor een deel van een kg",
            "content": "750 gram = 0,75 kg.\nVermenigvuldig de kiloprijs met het gewicht in kg:\n€2,40 × 0,75 = €1,80.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Eerst reken je de grammen om naar kilogrammen: 750 gram = 0,75 kg (of 3/4 kg). De prijs is €2,40 per kg. Vermenigvuldig de kiloprijs met het gewicht: €2,40 × 0,75 = €1,80. Je betaalt dus €1,80 voor 750 gram appels.",
        "solutionSteps": [
          "Reken om: 750 g = 0,75 kg",
          "Kiloprijs: €2,40",
          "Prijs: €2,40 × 0,75 = €1,80"
        ],
        "distractorExplanations": {
          "0": "Goed! €2,40 × 0,75 = €1,80.",
          "1": "Je dacht waarschijnlijk dat 750 gram hetzelfde is als 1 kg. Maar 750 g = 0,75 kg, dus je betaalt minder dan de volle kiloprijs. Onthoud: reken eerst om naar kg.",
          "2": "Je dacht waarschijnlijk dat 750 g = 0,5 kg. Maar 750 g = ¾ kg = 0,75 kg. €2,40 × 0,75 = €1,80, niet €1,20. Onthoud: 750 g = driekwart kg.",
          "3": "Je dacht waarschijnlijk dat je €2,40 + iets moest doen. Maar 750 g is minder dan 1 kg, dus de prijs is lager dan €2,40. Onthoud: minder dan 1 kg = minder dan de kiloprijs."
        }
      }
    },
    {
      "id": "GELD-PRIJS-PER-005",
      "familyId": "GELD-PRIJS-PER",
      "module": "Geld",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_prijs_per_eenheid",
      "questionType": "fill_in",
      "question": "Een doos met 6 eieren kost €1,80. Hoeveel kost één ei? Typ het bedrag (bijv. 0,30).",
      "context": "Je wilt weten hoeveel één ei kost als je een doos van 6 koopt.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["0,30", "0.30", "€0,30", "€0.30"],
        "caseSensitive": false,
        "placeholder": "€..."
      },
      "conceptId": "prijs_per_stuk_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Prijs per stuk berekenen",
            "content": "Deel de totaalprijs door het aantal stuks:\n€1,80 ÷ 6 = €0,30 per ei.\nReken in centen: 180 ÷ 6 = 30 cent = €0,30.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Om de prijs van één ei te berekenen, deel je de totaalprijs door het aantal eieren. De doos kost €1,80 en er zitten 6 eieren in. De som is: €1,80 ÷ 6 = €0,30 per ei. Een handige manier is om in centen te rekenen: 180 cent ÷ 6 = 30 cent, wat gelijk is aan €0,30.",
        "solutionSteps": [
          "Totaalprijs: €1,80",
          "Aantal eieren: 6",
          "Per ei: €1,80 ÷ 6 = €0,30"
        ]
      }
    },
    {
      "id": "GELD-PRIJS-PER-006",
      "familyId": "GELD-PRIJS-PER",
      "module": "Geld",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_prijs_per_eenheid",
      "questionType": "step_solver",
      "question": "In de supermarkt staan twee pakken rijst. Pak A: 750 gram voor €1,80. Pak B: 1 kg voor €2,20. Reken stap voor stap uit welk pak goedkoper is per kilogram.",
      "context": "Je vergelijkt twee pakken rijst om de beste deal te vinden.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "stepSolver": {
          "context": "",
          "steps": [
            {
              "prompt": "Wat is de kiloprijs van pak A? (€1,80 ÷ 0,75 kg = ...)",
              "correctAnswer": "2,40",
              "acceptedAnswers": ["2,40", "2.40", "€2,40", "2,4", "2.4"],
              "hint": "750 gram = 0,75 kg. Deel de prijs door het gewicht in kg."
            },
            {
              "prompt": "Wat is de kiloprijs van pak B? (€2,20 ÷ 1 kg = ...)",
              "correctAnswer": "2,20",
              "acceptedAnswers": ["2,20", "2.20", "€2,20", "2,2", "2.2"],
              "hint": "Pak B is al 1 kg, dus de kiloprijs is gelijk aan de prijs."
            },
            {
              "prompt": "Welk pak is goedkoper per kg? Typ A of B.",
              "correctAnswer": "B",
              "acceptedAnswers": ["B", "b", "Pak B", "pak B", "pak b"],
              "hint": "Vergelijk: €2,40/kg vs €2,20/kg"
            }
          ],
          "showStepsProgressively": true
        }
      },
      "conceptId": "prijs_per_kg_step_solver",
      "variantIndex": 6,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2
      },
      "stimulusAids": [
        {
          "type": "priceCompare",
          "data": {
            "items": [
              { "name": "Pak A", "quantity": 0.75, "unit": "kg", "totalPrice": 1.80 },
              { "name": "Pak B", "quantity": 1, "unit": "kg", "totalPrice": 2.20 }
            ],
            "compareUnit": "per kg",
            "label": "Vergelijk de prijs per kilogram"
          }
        }
      ],
      "supportAids": [
        {
          "type": "priceCompare",
          "showWhen": "wrong",
          "data": {
            "items": [
              { "name": "Pak A (750 g)", "quantity": 0.75, "unit": "kg", "totalPrice": 1.80 },
              { "name": "Pak B (1 kg)", "quantity": 1, "unit": "kg", "totalPrice": 2.20 }
            ],
            "compareUnit": "per kg",
            "label": "Prijs per kg vergelijken"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bereken de kiloprijs voor beide pakken. Pak A: 750 g = 0,75 kg, dus €1,80 ÷ 0,75 = €2,40 per kg. Pak B: €2,20 ÷ 1 = €2,20 per kg. Pak B is 20 cent goedkoper per kilogram.",
        "solutionSteps": [
          "Pak A: €1,80 ÷ 0,75 kg = €2,40 per kg",
          "Pak B: €2,20 ÷ 1 kg = €2,20 per kg",
          "€2,20 < €2,40 → Pak B is goedkoper per kg"
        ]
      }
    }
  ]
}